import { render, staticRenderFns } from "./SummaryMetricRows.vue?vue&type=template&id=2675ad56&scoped=true"
import script from "./SummaryMetricRows.vue?vue&type=script&lang=js"
export * from "./SummaryMetricRows.vue?vue&type=script&lang=js"
import style0 from "./SummaryMetricRows.vue?vue&type=style&index=0&id=2675ad56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2675ad56",
  null
  
)

export default component.exports